export const orderCheckout = {
  state: {},
  mutations: {},
  actions: {},
  getters: {}
}
